export default __webpack_public_path__ + "static/media/assignment-12-angle.caaab530.svg";